import { Country } from "src/models/account-information.model";


export function countryNameOption(currentLanguage: string, item: Country): string {
  return `${currentLanguage === 'es' ? item.esOfficialName : item.enOfficialName} (+${item.dial})`;
};
